module.exports = __webpack_public_path__ + "src/assets/img/27.8e9c67ee.svg";